import { PayloadAction, combineReducers } from "@reduxjs/toolkit";
import auth from "./auth";
import users from "./users";
const rootReducer = combineReducers({
  auth,
  users,
});

export const reducer = (state: any, action: PayloadAction<any>) => {
  if (action.type === "clearRedux") {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};
